<p-dialog
  header="Run Asset Depreciation"
  [(visible)]="isVisible"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '520px' }"
  (onHide)="onClose()">

  <!-- Financial Year Selection -->
  <div class="mb-4">
    <label class="font-semibold text-sm mb-2 block">Financial Year</label>
    <p-select
      [options]="financialYearOptions"
      [(ngModel)]="selectedFinancialYear"
      optionLabel="label"
      optionValue="value"
      placeholder="Select Financial Year"
      [style]="{ width: '100%' }"
      size="small"
      [disabled]="isLoading || previewGenerated">
    </p-select>
  </div>

  <!-- Generate Preview Button -->
  <div *ngIf="!previewGenerated" class="action-buttons">
    <p-button
      label="Generate Preview"
      (onClick)="generatePreview()"
      [disabled]="!selectedFinancialYear || isLoading"
      [loading]="isLoading">
    </p-button>
  </div>

  <!-- Preview Summary -->
  <div *ngIf="previewGenerated" class="mt-4">
    <div class="summary-card mb-4">
      <div class="summary-row">
        <span class="summary-label">Run Number</span>
        <span class="summary-value">{{ runNumber }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Total Assets</span>
        <span class="summary-value">{{ totalAssets }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Total Depreciation</span>
        <span class="summary-value">₹ {{ totalDepreciation | number:'1.2-2' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Status</span>
        <p-tag [value]="status | titlecase" [severity]="status === 'applied' ? 'success' : 'info'"></p-tag>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <p-button
        label="Download Excel"
        icon="pi pi-download"
        severity="secondary"
        [outlined]="true"
        (onClick)="downloadExcel()"
        [loading]="isDownloading"
        [disabled]="!runId || isDownloading">
      </p-button>
      <p-button
        *ngIf="status !== 'applied' && status !== 'processing'"
        label="Approve & Apply"
        (onClick)="applyDepreciation()"
        [disabled]="isLoading"
        [loading]="isApplying">
      </p-button>
    </div>
  </div>

  <!-- Applied Success -->
  <div *ngIf="status === 'applied'" class="mt-3">
    <p class="text-sm text-green-600 font-medium">
      Depreciation has been applied successfully. The final Excel has been downloaded.
    </p>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="mt-3">
    <p class="text-sm text-red-500">{{ errorMessage }}</p>
  </div>

</p-dialog>
